import { useCallback, useState } from 'react'

import { useReduxDispatch } from '@/store/hooks'
import { toastActions } from '@/store/toast'
import { getImpactLink } from '@/utils/brandUtil'
import { parseError } from '@/utils/commonUtil'
import { fetchApi } from '@/utils/requestUtil'

type Props = {
  decklist: string[]
  onTrack?: (label: string) => void
}

export const useScgExport = ({ decklist, onTrack }: Props) => {
  const dispatch = useReduxDispatch()
  const [loading, setLoading] = useState(false)

  const onClick = useCallback(() => {
    if (loading || decklist.length < 1) return
    const cards = decklist.map((c) => c.slice(c.indexOf(' ') + 1))

    setLoading(true)
    void (async () => {
      try {
        const url = (
          await fetchApi<{ url?: string }>({
            base: 'api',
            options: {
              body: JSON.stringify({ cards }),
              headers: { accept: 'application/json', 'content-type': 'application/json' },
              method: 'post',
            },
            path: '/scg',
          })
        ).data.url

        if (!url) throw new Error('URL not found')

        const impactUrl = getImpactLink({
          brand: 'scg',
          subId1: 'edhrec,clipboard',
          u: url,
        })
        window.open(impactUrl, '_blank')
        onTrack?.(impactUrl)
      } catch (e) {
        dispatch(
          toastActions.add(
            <>
              <strong>SCG Export Error:</strong> {parseError(e, 'SCG Export error')}
            </>,
          ),
        )
      } finally {
        setLoading(false)
      }
    })()
  }, [dispatch, loading, decklist, onTrack])

  return { loading, onClick }
}
